import { Box } from 'core/components';
import React, { PropsWithChildren } from 'react';

function PlanCardMainContentWrapper({ children }: PropsWithChildren<object>): JSX.Element {
  return (
    <Box flex="1" maxWidth="60%">
      {children}
    </Box>
  );
}

export default PlanCardMainContentWrapper;
